import type {ReactElement} from 'react';
import {createPortal} from 'react-dom';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Text, TextSize} from '@Components/text';
import {useDismissOnOutsideInteraction} from '@Components/qr-code-generator/qr-code-generator-hooks';
import styles from './qr-action-sheet.module.scss';
import type {QRActionSheetProps} from './qr-action-sheet.types';

export function QRActionSheet({label, onClose, children}: QRActionSheetProps): ReactElement {
  const sheetRef = useDismissOnOutsideInteraction(true, onClose);

  return createPortal(
    <div className={styles.qrActionSheetOverlay}>
      <div ref={sheetRef} className={styles.qrActionSheet} role="dialog" aria-modal="true" aria-label={label}>
        <header className={styles.qrActionSheetHeader}>
          <Text val={label} size={TextSize.LG} bold className={styles.qrActionSheetTitle} />
          <Icon
            icon="icon-close"
            size={IconSize.SIZE_ICON_20}
            isUsedAsButton
            ariaLabel={window.i18next.t('pmwjs_qr_generator_close')}
            className={styles.qrActionSheetClose}
            onClick={onClose}
          />
        </header>

        <div className={styles.qrActionSheetBody}>{children}</div>
      </div>
    </div>,
    document.body
  );
}
